import React from "react";
import {Form, Formik} from "formik";
import {Spinner, Stack} from "@fluentui/react";
import OnOffSettingsFields from "./OnOffSettingsFields";
import {mapValuesForSubmit} from "./OnOffSettingsPage";

import useAxios from "axios-hooks";
import { NavigationalButtons } from "./CreateAudioWizard";

const OnOffStep = ({ nextOnClick, prevOnClick, audioId, audio}) => {
    const [{ data: onOffSetting, loading: loadingOnOffSetting }] = useAxios(
        {
          url:`/resources/audio/${audioId}/on-off`, method: "get"
        }
    );

    const [{ loading, data, error }, postForm] = useAxios(
        {
            url: `/resources/audio/${audioId}/on-off`,
            method: "post",
        },
        { manual: true }
    );

    if (loadingOnOffSetting) {
        return (
            <Spinner className="absolute-center" label="Retrieving Settings..." />
        );
    }

  return (
      <Formik
          initialValues={onOffSetting}
          onSubmit={async (values) => {
              try {
                  await postForm({ data:values });
              } catch (e) {
                  throw e;
              }

              nextOnClick();
          }}
      >
    <Form>
      <Stack
        tokens={{ childrenGap: 20 }}
        styles={{
          root: {
            width: 300,
            paddingTop: 20,
          },
        }}
      >
        <OnOffSettingsFields setOptionTable={()=>{}} />
        <NavigationalButtons
            onNextProps={{ type: "submit", text: "Save and Continue" }}
            loading={loading}
            onPrevHandler={prevOnClick}
        />
      </Stack>
    </Form>
      </Formik>
  );
};

export default OnOffStep;
